const data = {
  id: 1,
  title: ' Choose the correct sentence.',
  subTitle: '(Chọn câu đúng)',
  answers: [
    { id: 1, answer: 'I will see you later', isCorrect: true },
    { id: 2, answer: 'I am see you later', isCorrect: false },
    { id: 3, answer: 'I are see you later', isCorrect: false },
    { id: 4, answer: 'I seeing you later', isCorrect: false },
  ],
};

export default data;
